import SearchAction from './header-actions-entities/search.js';
import UserAction from './header-actions-entities/user.js';
import CartAction from './header-actions-entities/cart.js';
import ComparerAction from './header-actions-entities/comparer.js';
import SelectorAction from './header-actions-entities/selector.js';
import { headerTippyInstances } from './header-actions-entities/instance-builders/shared-objects.js';

const header = {

	reset: () => {
		for (const instance of headerTippyInstances) {
			instance.destroy();
		}
		headerTippyInstances.clear();
	},

	// Search button actions
	search: new SearchAction(),

	// User button actions
	user: new UserAction(),

	// Cart button actions
	cart: new CartAction(),

	// Comparer button actions
	comparer: new ComparerAction(),

	// Locale/Currency Selector
	selector: new SelectorAction(),
};

export default header;
